import { group as d3Group } from "d3-array";
import { Entidad } from "../../data/Entidad";
import { DataModuloMain } from "../../data/ModuloMain";
import { _DICC_FULL_ESCUELAS } from "../../data/modulo/Escuela";
import { _DICC_AGRUPADORES_FULL, _SvFinanzasObtenerListaAgrupadorCargos } from "../../data/modulo/FinanzaAgrupadorCargos";
import { _SvFinanzasActualizarCargoDescuento, _SvFinanzasEliminarCargo, _SvFinanzasNuevoCargoDescuento } from "../../data/modulo/FinanzaCargo";
import _L from "../../util/Labels";
import { IConfigGridExcelExport, IGridExtraTableConfig, IGridRenderInfo, VentanaGrid } from "../controlD3/AVentanaGrid";
import { ExcelThings } from "../controlD3/ExcelExport";
import { _ModalSimple } from "../controlD3/ModalThings/ModalSimple";
import { Table } from "../controlD3/Tabla";
import { UIUtilFormat } from "../util/Format";
import { UIUtilViewData } from "../util/ViewData";
import { FinanzaAgrupadorCargosModal } from "../utilView/FinanzasIngresos/FinanzaAgrupadorCargosModal";
import { UIUtilViewFinanzaCargo } from "../utilView/FinanzasIngresos/FinanzaCargo";
import { _GetFinanzaCargoForm } from "../utilView/FinanzasIngresos/FinanzaCargoForm";
import { GetFinanzaDescuentoForm } from "../utilView/FinanzasIngresos/FinanzaDescuentoForm";
import { UIUtilViewFinanzasIngresoUtil } from "../utilView/FinanzasIngresos/FinanzasIngresoUtil";

import CCategoriaTipoFinanza = Entidad.CFinanzaCargoCategoria;
import CTipoValor = Entidad.CFinanzaCargoTipoValor;
import IFinanzaCargo = Entidad.IFinanzaCargo;
import CAccionPermiso = Entidad.CAccionPermiso;

export class UIVentanaFinanzasCargos extends VentanaGrid<IFinanzaCargo> {

    constructor(content: d3.Selection<HTMLDivElement, undefined, HTMLElement, any>, modulo: Entidad.CModulo) {
        super(content, modulo);
    }

    protected GRID_GetDataRequestID(): DataModuloMain.TipoRequestMonitorId {
        return Entidad.CTipoRequest.FinanzaCargo;
    }

    protected GridGetData(): Promise<Entidad.IFinanzaCargo[]> {
        this.ConsultarAgrupadores();
        return super.GridGetData();
    }

    protected GRID_GetTableConfigBase(): IGridRenderInfo<IFinanzaCargo> {
        return {
            IdTabla: "FinanzasCatalogos-Ingresos",
            DefaultSort: "Nombre",
            IdData: "ID",
            MinWidth: 800,
            Columns: [
                {
                    Field: "Nombre", Label: "Nombre", Width: "30%", MinWidth: "75px", ClassStyle: "link_item",
                    OnClickInCellCont: (datum, event) => {
                        console.debug("Vent_FinCargo&Desc ->", datum)
                        if (this.GridHasPermisoAccion(CAccionPermiso.Ver)) {
                            this.OpenModal_Informacion(datum);
                        }
                    }
                },
                {
                    Field: "Valor", Label: "Valor", Width: "15%", MinWidth: "75px",
                    RenderCell: (v: number, _, datum) => (datum.TipoValor == CTipoValor.Monto)
                        ? UIUtilFormat._CurrencyFmt(v)
                        : UIUtilFormat._PercentFmt(v)
                },
                { Field: "StrCategoria", Label: "Categoria", Width: "15%", MinWidth: "90px" },
                { Field: "getValorRecargoFmt", Label: "recargos", Width: "20%", MinWidth: "85px" },
                { Field: "StrEscuela", Label: "Escuela", Width: "20%", MinWidth: "75px" },
            ],
        }
    }

    protected GRID_GetTableConfigAdvanced(): IGridExtraTableConfig<IFinanzaCargo> {
        return {
            EvaluatorAndSubLevelsBuild: {
                OnStepCellTable: (container, datum, field: keyof IFinanzaCargo) => {
                    if (field == "Nombre") {
                        UIUtilViewFinanzaCargo._RenderCargoNombre(datum, container.node());
                    }
                }
            },
            FilterByStrSearch: (d) => [
                d.Nombre, d.Valor.toString(), d.StrCategoria, d.getValorRecargoFmt, d.StrEscuela,
                (d.IdAgrupador > 0 && _DICC_AGRUPADORES_FULL.get(d.IdEscuela)?.has(d.IdAgrupador)) ? _DICC_AGRUPADORES_FULL.get(d.IdEscuela)?.get(d.IdAgrupador)?.Prefix : "",
                [CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida].includes(d.Categoria) ? _L("finanzascargo.tag_cargo_preestablecido_info") : ""
            ],
        }
    }

    protected GRID_GetFilters(): Array<Table.IParametroFiltro<IFinanzaCargo>> {
        return [
            { Field: "Nombre", Label: "Nombre", OnGetValueToMatch: (d,) => [d.Nombre, ([CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida].includes(d.Categoria) ? _L("finanzascargo.tag_cargo_preestablecido_info") : "")] },
            { Field: "Valor", Label: "Valor", Type: "number" },
            {
                Field: "Categoria",
                LabelLangKey: "d_field_strcategoria",
                Type: "select",
                Options: UIUtilViewData._GetList_CargoCategoria()
            },
            { Field: "getValorRecargoFmt" },
        ]
    }

    protected GRID_GetMenuTopGrid(): Array<Table.ITableMenuTopDefaultOptionConfig> {
        let opciones: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        if (this.GridHasPermisoAccion(CAccionPermiso.Agregar)) {
            opciones.push({
                Label: "action_addcargo",
                Callback: () => {
                    const formCargo = _GetFinanzaCargoForm(CAccionPermiso.Agregar);
                    UIUtilViewFinanzaCargo._OpenModal_FormAddEditCargo(CAccionPermiso.Agregar, formCargo._Data, formCargo, "FinanzasCargos");
                }
            });
        }

        if (this.GridHasPermisoAccion(CAccionPermiso.AgregarDescuentos)) {
            opciones.push({
                Label: "action_adddesc",
                Callback: () => { this.OpenModal_FormAddDesc() }
            });
        }

        const someKinderUsaFactura = this.ObtenerEscuelasList().some(e => e.UsaFactura);
        if (someKinderUsaFactura) {
            opciones.push({
                Label: _L("finanzascargo.agrupador.modal_title"),
                Callback: () => { new FinanzaAgrupadorCargosModal() }
            })
        }
        return opciones
    }

    protected GRID_GetSelectionDataMenuV2(menuLocation: "row" | "top-selected", dataGridSelected: IFinanzaCargo[]): Table.ITableMenuDataSelectedOptionConfig<IFinanzaCargo>[] {
        let opciones: Array<Table.ITableMenuDataSelectedOptionConfig<IFinanzaCargo>> = [];

        if (this.GridHasPermisoAccion(CAccionPermiso.Editar)) {
            opciones.push({
                Label: "Editar",
                MultiData: false,
                Callback: (datos: Array<IFinanzaCargo>) => {
                    const datoCargoDesc = { ...datos[0] };
                    console.debug("Vent_FinCargo&Desc ->", datos)

                    const tiposCargo = [CCategoriaTipoFinanza.Cargo, CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida]
                    if (tiposCargo.includes(datoCargoDesc.Categoria)) {
                        const formCargo = _GetFinanzaCargoForm(CAccionPermiso.Editar, datoCargoDesc);
                        UIUtilViewFinanzaCargo._OpenModal_FormAddEditCargo(CAccionPermiso.Editar, datoCargoDesc, formCargo, "FinanzasCargos");
                    } else if (datoCargoDesc.Categoria == CCategoriaTipoFinanza.Descuento) {
                        this.OpenModal_FormEditDesc(datoCargoDesc);
                    }
                }
            });
        }

        if (this.GridHasPermisoAccion(CAccionPermiso.Eliminar)) {
            opciones.push({
                Label: "Eliminar",
                Callback: (datos: Array<IFinanzaCargo>) => this.OpenModal_Eliminar(datos),
                GetDetails: (datos) => {
                    let enable = true;
                    let message = '';
                    if (!datos.every(d => (d.Categoria != CCategoriaTipoFinanza.CargoEntrada && d.Categoria != CCategoriaTipoFinanza.CargoSalida))) {
                        enable = false;
                        message = this.VB_GetUIStringModule("tlt_eliminar_desc_fail");
                    }
                    return {
                        Enabled: enable,
                        Description: message
                    }
                }
            });
        }
        return opciones;
    }


    protected GRID_GetExportarConfig(dataGrid: IFinanzaCargo[]): IConfigGridExcelExport<any> {
        return {
            IdsEscuelas: [...new Set(dataGrid.map(d => d.IdEscuela))],
            ColumnsConfig: this.ctrlTabla
                ._InfoColumns
                .map<ExcelThings.IColumnToExcelExportFileConfig<IFinanzaCargo>>((d) => ({
                    Field: d.Field as keyof IFinanzaCargo,
                    HeaderTag: d.Label,
                    WidthCell: 25
                })),
            OnGetDataBySheets: async () => {
                return Array.from(d3Group(dataGrid, d => d.IdEscuela))
                    .map<ExcelThings.ISheetConfig<IFinanzaCargo>>(entrie => ({
                        IdSheet: entrie[0], // IdEscuela
                        SheetName: entrie[1][0].StrEscuela,
                        Data: entrie[1]
                    }))
            },
            OnGetEscuelasTagInSheet: (dataSheet) => dataSheet[0].StrEscuela,
            OnStepFieldInDataRow: (field, dato) => {
                switch (field) {
                    case "Valor":
                        return UIUtilFormat._CurrencyFmt(dato[field]); // Ajustar la celda Excel a currency, en lugar de mandar un string
                    default:
                        return dato[field];
                }
            }
        }
    }

    //***************************************************************************************
    // PROCESO AGREGAR/EDITAR DESCUENTO
    //***************************************************************************************

    private OpenModal_FormAddDesc() {
        this.GridOpenModal_ActionFormToAGridData({
            Width: 400,
            Action: CAccionPermiso.AgregarDescuentos,
            GetForm: () => GetFinanzaDescuentoForm(CAccionPermiso.AgregarDescuentos, <IFinanzaCargo>{ Categoria: CCategoriaTipoFinanza.Descuento, TipoValor: CTipoValor.Monto }),
            OnAccept: (form, mt) => {
                let formData = form._Data;
                return _SvFinanzasNuevoCargoDescuento(formData);
            }
        })
    }

    private OpenModal_FormEditDesc(descuento: IFinanzaCargo) {
        this.GridOpenModal_ActionFormToAGridData({
            Width: 400,
            Action: CAccionPermiso.Editar,
            IdsEscuelas: [descuento.IdEscuela],
            GetForm: () => GetFinanzaDescuentoForm(CAccionPermiso.Editar, descuento),
            OnAccept: (form, mt) => {
                let formData = form._Data;
                return _SvFinanzasActualizarCargoDescuento(formData);
            }
        })
    }

    private OpenModal_Eliminar(datos: Array<IFinanzaCargo>) {
        this.GridOpenModal_ProccessArrayData({
            DataToProccess: datos,
            Message: "confirma_eliminar",
            Width: 350,
            OnGetIdEscuela: (dato) => dato.IdEscuela,
            OnError_GetItemDataTag: (dato) => `${dato.Nombre} (${_DICC_FULL_ESCUELAS.get(dato.IdEscuela)?.Nombre})`,
            OnStepAProccess: null,
            OnStepAllProccess: () => _SvFinanzasEliminarCargo(datos.map(d => d.ID))
        })
    }

    private OpenModal_Informacion(dato: IFinanzaCargo) {
        const esDescuento = dato.Categoria == CCategoriaTipoFinanza.Descuento;
        _ModalSimple({
            Title: _L(esDescuento ? "finanzascargo.tag_info_descuento_title" : "finanzascargo.tag_info_cargo_title"),
            Width: esDescuento ? 400 : 490,
            DrawContent: (content, modalThings) => {
                UIUtilViewFinanzaCargo._RenderCargoDescuentoDetails(dato, content.node());
            }
        })
    }

    private ConsultarAgrupadores() {
        if (timeoutAgrupadores) {
            clearTimeout(timeoutAgrupadores);
        }
        timeoutAgrupadores = setTimeout(async () => {
            timeoutAgrupadores = null;
            const escuelas = this.ObtenerEscuelasList();
            for (const escuela of escuelas) {
                await _SvFinanzasObtenerListaAgrupadorCargos(escuela.IdKinder)
            }
            this.ctrlTabla._RefreshView();
        }, 1200);
    }
}

let timeoutAgrupadores: NodeJS.Timeout;